import { Box, Button, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import type { WizardState, WizardAction } from '../ImportWizard';

interface Step2Props {
  state: WizardState;
  dispatch: React.Dispatch<WizardAction>;
  onNext: (patch?: Record<string, unknown>) => Promise<void>;
  onBack: () => void;
}

export function Step2TimetableDecision({ state, dispatch, onNext, onBack }: Step2Props) {
  const canAdvance = state.includeTimetable !== null;

  const handleNext = async () => {
    await onNext({ include_timetable: state.includeTimetable });
  };

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h6">Step 2: Include Timetable Data?</Typography>
      <Typography variant="body2" color="text.secondary">
        Choose whether to include timetable data in this import. You can perform a
        master-data-only load if needed.
      </Typography>

      <RadioGroup
        value={state.includeTimetable === null ? '' : String(state.includeTimetable)}
        onChange={(e) =>
          dispatch({ type: 'SET_INCLUDE_TIMETABLE', payload: e.target.value === 'true' })
        }
      >
        <FormControlLabel value="true" control={<Radio />} label="Yes — include timetable data" />
        <FormControlLabel value="false" control={<Radio />} label="No — master data only" />
      </RadioGroup>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" disabled={!canAdvance} onClick={handleNext}>
          Next
        </Button>
      </Box>
    </Box>
  );
}
